import { render, staticRenderFns } from "./StockAdjustmentHistory.vue?vue&type=template&id=3fded488"
import script from "./StockAdjustmentHistory.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentHistory.vue?vue&type=script&lang=js"
import style0 from "./StockAdjustmentHistory.vue?vue&type=style&index=0&id=3fded488&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports